__turbopack_context__.v({
  "apply": "classroom-module__uaEjea__apply",
  "arrow": "classroom-module__uaEjea__arrow",
  "body": "classroom-module__uaEjea__body",
  "card": "classroom-module__uaEjea__card",
  "fadeIn": "classroom-module__uaEjea__fadeIn",
  "insetIn": "classroom-module__uaEjea__insetIn",
  "label": "classroom-module__uaEjea__label",
  "num": "classroom-module__uaEjea__num",
  "pulse": "classroom-module__uaEjea__pulse",
  "relight": "classroom-module__uaEjea__relight",
  "ring": "classroom-module__uaEjea__ring",
  "root": "classroom-module__uaEjea__root",
  "sonar": "classroom-module__uaEjea__sonar",
  "text": "classroom-module__uaEjea__text",
  "who": "classroom-module__uaEjea__who",
});
